// react_frontend/src/Components/Modules/Accounting/TrialBalance.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Chip
} from '@mui/material';
import { FaSearch, FaFileExport } from 'react-icons/fa';

export default function TrialBalance() {
    const [data, setData] = useState([]);
    const [totals, setTotals] = useState({ debit: 0, credit: 0, balanced: false });
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchTrialBalance = async () => {
        setLoading(true);
        try {
            const res = await AxiosAuthInstance.get('accounting/reports/trial-balance', {
                params: { from_date: fromDate, to_date: toDate }
            });
            setData(res.data.data || []);
            setTotals(res.data.totals || {});
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchTrialBalance(); }, []);

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Trial Balance" />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" fontWeight={700} mb={2}>Trial Balance</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField label="From Date" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <TextField label="To Date" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <Button variant="contained" onClick={fetchTrialBalance} startIcon={<FaSearch />}>Generate</Button>
                </Box>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                                <TableCell>Code</TableCell>
                                <TableCell>Account Name</TableCell>
                                <TableCell align="right">Debit</TableCell>
                                <TableCell align="right">Credit</TableCell>
                                <TableCell align="right">Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell><code>{row.account_code}</code></TableCell>
                                    <TableCell>{row.account_name}</TableCell>
                                    <TableCell align="right">৳{Number(row.debit).toLocaleString()}</TableCell>
                                    <TableCell align="right">৳{Number(row.credit).toLocaleString()}</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600 }}>৳{Number(row.balance).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#e3f2fd', fontWeight: 700 }}>
                                <TableCell colSpan={2}><strong>Total</strong></TableCell>
                                <TableCell align="right"><strong>৳{Number(totals.debit).toLocaleString()}</strong></TableCell>
                                <TableCell align="right"><strong>৳{Number(totals.credit).toLocaleString()}</strong></TableCell>
                                <TableCell align="right">
                                    <Chip label={totals.balanced ? 'Balanced ✓' : 'Not Balanced ✗'} color={totals.balanced ? 'success' : 'error'} />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
}